<template>
<console-content max-width="1024">
    <v-row align="end" class="mt-3">
        <v-col cols="auto">
            <span class="headline">핀 업데이트</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-0">
            <v-btn color="white" @click="download('/excel/example_update_v1.1.xlsx')" class="green--text">
                <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>양식다운로드
            </v-btn>
        </v-col>
    </v-row>

    <v-card class="mt-3">
        <v-card-title>
            <v-row align="center" justify="end">
                <v-col cols="12" md="6" class="py-0">
                    <v-file-input accept=".xlsx" label="업로드 파일(.xlsx)" placeholder=" " @change="importExcel" hide-details
                                :prepend-icon="mdiMicrosoftExcel" ></v-file-input>
                </v-col>
                <v-spacer/>
                <v-col cols="auto" class="py-0 pr-0">
                    <v-select v-model="expiration" :items="expirationItems" item-text="name" item-value="_id" return-object label="만기기간" placeholder=" " hide-details></v-select>
                </v-col>
                <v-col cols="auto" class="py-0 pr-0">
                    <v-btn color="primary" class="mr-4" :loading="loading" @click="update">저장</v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-0">
            <v-data-table :headers="pinHeaders" :items="pins" disable-sort disable-pagination hide-default-footer></v-data-table>
        </v-card-text>
    </v-card>
</console-content>
</template>

<script>
import api from "@/api";

import download from "downloadjs";
import XLSX from "xlsx";
import dayjs from "dayjs";
import { mdiMicrosoftExcel } from "@mdi/js";
import ConsoleContent from "@/components/console/console-content.vue";

export default {
    components: {
        ConsoleContent
    },
    data() {
        return {
            mdiMicrosoftExcel,

            loading: false,
            expiration: { _id: 2, type: "year", value: 5 },
            expirationItems: [
                { _id: 0, name: "30일", type: "day", value: 30 },
                { _id: 1, name: "60일", type: "day", value: 60 },
                { _id: 2, name: "5년", type: "year", value: 5 }
            ],

            sheet: [],
            pinHeaders: [
                {
                    text: "핀번호",
                    align: "center",
                    value: "pno",
                },
                {
                    text: "연락처",
                    align: "center",
                    value: "phone"
                },
                {
                    text: "판매시간",
                    align: "center",
                    value: "issuedAt"
                },
                {
                    text: "만기일자",
                    align: "center",
                    value: "expiredAt"
                }
            ],
        };
    },
    methods: {
        download,
        importExcel(file) {
            if(!file) return;

            let reader = new FileReader();
            reader.onload = () => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: 'binary' });
                workBook.SheetNames.forEach(sheetName => {
                    let sheet = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                    workSheets.push(sheet);
                });

                this.sheet = workSheets[0]; // 첫번째 시트
            };
            reader.readAsBinaryString(file);
        },

        validate(){
            try{
                if(!this.pins.length) throw new Error("엑셀 양식에 맞게 핀을 업로드 해주시기 바랍니다");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async update(){
            this.loading = true;

            if(this.validate()){
                await api.console.pins.update({ pins: this.pins });
    
                alert("업데이트 되었습니다");
            }

            this.loading = false;
        },
    },
    computed: {
        pins(){
            var pins = [];
            for(var row of this.sheet){
                pins.push({
                    pno: row["핀번호"],
                    phone: row["구매자 연락처"] || "",
                    issuedAt: dayjs(row["판매일시"]).format("YYYY-MM-DD HH:mm:ss"),
                    expiredAt: dayjs(row["만기일시"]).add(this.expiration.value, this.expiration.type).format("YYYY-MM-DD HH:mm:ss")
                });
            }
            return pins;
        },
    },
}
</script>
